import {logout} from '../slice/userSlice';
import {postLogout} from '@/api/auth';
import {API_URL} from '@/config/api';
import {logoutFirebase} from '@/config/firebase';
import {getAccessToken, refreshAccessToken} from '@/utils/token-manager';
import {
  BaseQueryApi,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  fetchBaseQuery
} from '@reduxjs/toolkit/dist/query';

const baseQuery = fetchBaseQuery({
  baseUrl: API_URL,
  prepareHeaders: async (headers) => {
    const token = getAccessToken();
    if (token) {
      headers.set('Authorization', 'Bearer ' + token);
    }
    return headers;
  }
});

export const baseQueryWithReAuth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    try {
      const newAccessToken = await refreshAccessToken();
      if (newAccessToken) {
        result = await baseQuery(args, api, extraOptions);
      } else {
        await forcedLogout(api);
      }
    } catch (err) {
      await forcedLogout(api);
    }
  }
  if (result.error && result.error.status === 403) {
    await forcedLogout(api);
  }
  return result;
};

const forcedLogout = async (api: BaseQueryApi) => {
  await postLogout();
  localStorage.clear();
  await logoutFirebase();
  api.dispatch(logout());
};
